import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyResponse } from '@nx-c4g/c4g-models';
import { BaseSurveyStepComponent } from '../base-survey-step/base-survey-step.component';

@Component({
  selector: 'c4g-rating-survey-step',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rating-survey-step.component.html',
  styleUrls: ['./rating-survey-step.component.scss']
})
export class RatingSurveyStepComponent extends BaseSurveyStepComponent {
  // Use this.stepData and this.emitResponse in your logic

  emitTest() {
    this.emitResponse({
      stepId: this.stepData._id,
      showValueInReport: false,
      response: [
        { _id: 'test-option', values: ['test-value'] }
      ]
    });
  }

  override async getResponse(): Promise<SurveyResponse | undefined> {
    // Use this.stepData and this.emitResponse in your logic
    // Implement your logic here
    return undefined;
  }
}
